import typography from './typography'
import layout from './layout'
import palette from './palette'
import elevation from './elevation'
import globals from './globals'
import zIndex from './zIndex'
import internalMixins from './internalMixins'
import breakpoints from './breakpoints'
import state from './state'
import components from './components'
import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  spacing: 10,
  typography,
  layout,
  palette,
  elevation,
  globals,
  zIndex,
  internalMixins,
  breakpoints: {
    values: breakpoints,
  },
  state,
  components,
})

export default theme
